import AbstractAccountGroupRow from "./AccountGroupRow.js";

/**
 * Special row group used for dynamically generated CoA account groups.
 *
 * @param {boolean} spec.excluded - True if the row should only be
 * visible in the report editor and be shown as excluded from its
 * parent.
 */
export default class GeneratedAccountGroupRow extends AbstractAccountGroupRow {
	constructor({ excluded }) {
		super(...arguments);
		this._excluded = excluded;
	}

	isGenerated() {
		return true;
	}

	isExcluded() {
		return this._excluded;
	}

	canBeReferenced() {
		return false;
	}

	canBeUsedInFormulas() {
		return false;
	}

	canBeCalculated() {
		return !this.isExcluded();
	}

	canBeSelected() {
		return false;
	}

	canBeCollapsed() {
		return false;
	}

	accept(visitor) {
		return visitor.visitGeneratedAccountGroupRow(this);
	}

	static getType() {
		return "GeneratedAccountGroupRow";
	}
}
